export enum EnumAuthQueryKeys {
  AUTHENTICATED_USER = 'AUTHENTICATED_USER',
  AUTHENTICATORS = 'AUTHENTICATORS',
  SCA_ACTION = 'SCA_ACTION',
}
